export const CommutePreferenceDropdownItems = [
  { id: 'CAR', text: 'Car' },
  { id: 'TRANSIT', text: 'Transit' },
  { id: 'BIKE', text: 'Bike' },
  { id: 'SCOOTER', text: 'Scooter' },
  { id: 'MOPED', text: 'Moped' },
  { id: 'CARPOOL', text: 'Carpool' },
  { id: 'MULTIMODAL', text: 'Multimodal' },
  { id: 'OTHER', text: 'Other' },
]

export const EmployeeOnboardingContent = {
  extraInfo: {
    leftHeader: 'We need some more info to finish setting up your account.',
  },
  acceptTerms: {
    leftHeader:
      'Please Accept the Terms and Conditions for the Fleet Mobility Card',
  },
}
